import Multiselect from "multiselect-react-dropdown";
import React, { useEffect, useState } from "react";
import { AiFillEye } from "react-icons/ai";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import logo from "../../assets/img/logo.png";
import logoWhite from "../../assets/img/logo-white.png";
import Button from "../../components/Button";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import Input from "../../components/Input";
import CustomModal from "../../components/Modal";
import { GET_LOCALSTORAGE_JWT } from "../../config";
import { useLocalStorage } from "../../hooks/useLocalStorage";
import { ListMyPlanAction } from "../../store/actions/listMyPlanAction";
import { income } from "../../utils/income_mock";
import axios from "axios";
const ListMyPlan = () => {
  // import theme value from loaclstorage
  const [value] = useLocalStorage("theme", "light");
  // today date
  const today = new Date().toDateString();
  const [values, setValues] = useState({});
  const [file, setFile] = useState("");
  const [fileUrl, setFileUrl] = useState("");
  // handle file
  const handleFileChange = async (e) => {
    if (e.target.files.length !== 0) {
      setFile(URL.createObjectURL(e.target.files[0]))
    }
    console.log(file)
    const formData = new FormData();
    const inputFile = e.target.files[0];
    formData.append('image', inputFile);
    const url = `https://api.imgbb.com/1/upload?key=19fb92fe1b8cd35a2a9a4279d7c30606`;
    const result = await axios.post(url, formData)
    if (result.data.success) {
      setFileUrl(result.data.data.url)
      console.log(fileUrl);
    } else {
      e.target.value = '';
    }
  }

  const handleChange = (e) => {
    setValues({
      ...values,
      [e.target.name]: e.target.value,
      income_types: typesOfIncome,
      plan_category: planCategory,
      plan_pdf: fileUrl,
      date: today,
    });
    console.log(values)
  };
  const [typesOfIncome, setTypesOfIncome] = useState([]);
  const [planCategory, setPlanCategory] = useState([]);
  const dispatch = useDispatch();
  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(ListMyPlanAction(values));
  };
  // types of income select item
  const onSelect = (selectedList, _) => {
    const item = selectedList.map((d) => d.key);
    setTypesOfIncome(item);
  };
  // types of income remvoe item
  const onRemove = (selectedList, _) => {
    const item = selectedList.map((d) => d.key);
    setTypesOfIncome(item);
  };
  // Plan Category select item
  const onCategorySelect = (selectedList, _) => {
    const item = selectedList.map((d) => d.key);
    setPlanCategory(item);
  };
  // Plan Category remvoe item
  const onCategoryRemove = (selectedList, _) => {
    const item = selectedList.map((d) => d.key);
    setPlanCategory(item);
  };
  const navigate = useNavigate();
  useEffect(() => {
    if (!GET_LOCALSTORAGE_JWT("jwt_token")) {
      navigate("/login");
      toast.warning("You must be login first", {
        position: "top-center",
        pauseOnHover: false,
      });
    }
  }, [navigate]);

  // modal open close handler
  const [open, setOpen] = useState(false);
  const handleClose = () => setOpen(false);
  return (
    <>
      <Header />
      <div className="list_my_plan_wrapper">
        <div className="page_hero">
          <h2>List My Plan</h2>
        </div>
        <div className="container">
          <div className="list_plan_containers">
            <div className="field">
              <div className="form">
                <form onSubmit={handleSubmit} noValidate>
                  <div className="form_group">
                    <Input
                      label="Plan Name"
                      type="text"
                      name="plan_name"
                      className="input_field"
                      onChange={handleChange}
                      placeholder="Enter plan name"
                      isRequired={true}
                      inputGroupClass="left_field"
                    />
                    <div className="plan_category">
                      <label htmlFor="plan_category" className="label">
                        Plan Category <span style={{ color: "red" }}>*</span>{" "}
                      </label>
                      <Multiselect
                        displayValue="key"
                        onRemove={onCategoryRemove}
                        onSelect={onCategorySelect}
                        options={[
                          {
                            key: "Affiliate Markeing",
                          },
                          {
                            key: "Cryptocurrency",
                          },
                          {
                            key: "Free Plan",
                          },
                          {
                            key: "Freemlm",
                          },
                          {
                            key: "Refer & Earn",
                          },
                          {
                            key: "Stock Market",
                          },
                        ]}
                        placeholder="Select plan category"
                        showArrow={true}
                        singleSelect={true}
                      />
                    </div>
                  </div>
                  <div className="form_group">
                    <Input
                      label="Plan Website"
                      type="url"
                      name="plan_website"
                      className="input_field"
                      onChange={handleChange}
                      placeholder="Enter plan url"
                      isRequired={true}
                      inputGroupClass="left_field"
                    />
                    <Input
                      label="Joining Package (₹)"
                      type="number"
                      name="joining_package"
                      className="input_field"
                      onChange={handleChange}
                      placeholder="Enter joining package"
                      isRequired={true}
                    />
                  </div>
                  <div className="form_group">
                    <div className="types_of_income left_field">
                      <label htmlFor="types of incomef" className="label">
                        types of income <span style={{ color: "red" }}>*</span>{" "}
                      </label>
                      <Multiselect
                        displayValue="key"
                        onRemove={onRemove}
                        onSelect={onSelect}
                        options={income}
                        placeholder="Select types of income"
                        showArrow={true}
                        keepSearchTerm={true}
                      />
                    </div>
                    <Input
                      label="explain income types"
                      type="text"
                      name="explainincome_type"
                      className="input_field"
                      onChange={handleChange}
                      placeholder="Enter explain income type"
                      isRequired={false}
                    />
                  </div>
                  <div className="form_group">
                    <Input
                      label="Service/Products"
                      type="text"
                      name="service_product"
                      className="input_field"
                      onChange={handleChange}
                      placeholder="Enter service/product"
                      isRequired={true}
                      inputGroupClass="left_field"
                    />
                    <Input
                      label="referral Link/referral code"
                      type="text"
                      name="referral"
                      className="input_field"
                      onChange={handleChange}
                      placeholder="Enter referral link or code"
                      isRequired={true}
                    />
                  </div>
                  <div className="form_group">
                    <Input
                      label="Plan PDF"
                      type="file"
                      name="plan_pdf"
                      className="input_field"
                      onChange={handleFileChange}
                      isRequired={false}
                      inputGroupClass="left_field"
                    />
                    <Input
                      label="Contact US"
                      type="text"
                      name="contact_us"
                      className="input_field"
                      onChange={handleChange}
                      placeholder="Enter contact us"
                      isRequired={false}
                    />
                  </div>
                  <div className="form_group">
                    <Input
                      label="More information"
                      type="text"
                      name="more_info"
                      className="input_field"
                      onChange={handleChange}
                      placeholder="Enter more information"
                      isRequired={false}
                      inputGroupClass="left_field"
                      autoComplete="more_info"
                    />
                    <Input
                      label="date"
                      type="text"
                      name="date"
                      className="input_field"
                      onChange={handleChange}
                      value={today}
                      disabled={true}
                      autoComplete="date"
                    />
                  </div>
                  <div className="form_group d-flex justify-content-between">
                    <Button type="submit" className="glow neon">Submit</Button>
                    <Button
                      type="button"
                      onClick={() => setOpen(true)}
                      className="danger_btn preview_btn glow neon"
                    >
                      Preview <AiFillEye style={{ fontSize: "20px" }} />
                    </Button>
                  </div>
                </form>
              </div>
            </div>
            <CustomModal open={open} className="preview_modal" handleClose={handleClose}>
              <span className="close" onClick={() => setOpen(false)}>X</span>
              <div className="preview">
                <h2 className="title">preview</h2>
                <div className="preview_field">
                  {values.plan_name?.length > 0 && (
                    <div className="plan_name">
                      <h2>{values.plan_name}</h2>
                      <img src={value === "dark" ? logo : logoWhite} alt="logo" />
                    </div>
                  )}
                  <div className="preview_item">
                    {values.plan_name && (
                      <>
                        <span>Plan Name</span>
                        <h2>{values.plan_name}</h2>
                      </>
                    )}
                  </div>
                  <div className="preview_item">
                    {values.plan_category && (
                      <>
                        <span>Plan Category</span>
                        <p>{values.plan_category}</p>
                      </>
                    )}
                  </div>
                  <div className="preview_item">
                    {values.plan_website && (
                      <>
                        <span>Plan Url </span>
                        <a target="_blank" rel="noreferrer" href={values.plan_website.includes("http://") ? values.plan_website : `http://${values.plan_website}`}>{values.plan_website}</a>
                      </>
                    )}
                  </div>
                  <div className="preview_item">
                    {values.joining_package && (
                      <>
                        <span>Joining Package</span>
                        <p>
                          {values.joining_package && values.joining_package + "₹"}
                        </p>
                      </>
                    )}
                  </div>
                  <div className="preview_item">
                    {typesOfIncome.length > 0 && (
                      <>
                        <span>Types of incoome</span>
                        <p>
                          {typesOfIncome.map((d, i) => (
                            <span
                              style={{
                                fontWeight: "500",
                                fontSize: "14px",
                                color: "#000 !important",
                              }}
                              key={i + 1}
                            >
                              {d},{" "}
                            </span>
                          ))}
                        </p>
                      </>
                    )}
                  </div>
                  <div className="preview_item">
                    {values.explainincome_type && (
                      <>
                        <span>Explain Income Type</span>
                        <p>{values.explainincome_type}</p>
                      </>
                    )}
                  </div>
                  <div className="preview_item">
                    {values.service_product && (
                      <>
                        <span>Service/Product</span>
                        <p>{values.service_product}</p>
                      </>
                    )}
                  </div>
                  <div className="preview_item">
                    {values.referral && (
                      <>
                        <span>Referral Link or Code</span>
                        <p>{values.referral}</p>
                      </>
                    )}
                  </div>
                  <div className="preview_item">
                    {values.plan_pdf && (
                      <>
                        <p><span>Plan PDF</span></p>
                        <img src={fileUrl} alt="" height={200} width={200} />
                      </>
                    )}
                  </div>
                  <div className="preview_item">
                    {values.contact_us && (
                      <>
                        <span>Contact</span>
                        <p>{values.contact_us}</p>
                      </>
                    )}
                  </div>
                  <div className="preview_item">
                    {values.more_info && (
                      <>
                        <span>More Information</span>
                        <p>{values.more_info}</p>
                      </>
                    )}
                  </div>
                  <div className="preview_item">
                    {values.date && (
                      <>
                        <span>Date</span>
                        <p>{values.date}</p>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </CustomModal>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default ListMyPlan;
